import { createSlice } from '@reduxjs/toolkit';
import ProfessorTemplate from '../../util/ProfessorTemplate';
export const saveProfessorFormSlice = createSlice({
  name: 'saveProfessorForm',
  initialState: {
    content: ProfessorTemplate,
    selectedCollege: '',
    selectedInstitute: '',
    selectedProfessor: { id: 16305, name: ''},
    rating: 0,
  },
  reducers: {
    update: (state, action) => {
      state.content = action.payload.content;
      state.selectedCollege = action.payload.selectedCollege;
      state.selectedInstitute = action.payload.selectedInstitute;
      state.selectedProfessor = {
        id: action.payload.selectedProfessor.id,
        name: action.payload.selectedProfessor.name,
      };
      state.rating = action.payload.rating;
    },
    clearForm: (state) => {
      state.content = ProfessorTemplate;
      state.selectedCollege = '';
      state.selectedInstitute = '';
      state.selectedProfessor = { id: 16305, name: ''};
      state.rating = 0;
    },
  },
});
export const { update, clearForm } = saveProfessorFormSlice.actions;
export const saveProfessorForm = (state) => state.saveProfessorForm;
export default saveProfessorFormSlice.reducer;